"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fourteen/sections/testimonialsSection.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TestimonialsSectionSwipersItem = {
    key: Key | null | undefined;
    /** Detected variants: "Carolyn Ross" | "Jamie Aurora" | "Evelyn Reed" | "James Porter" */
    alt: string;
    /** Detected variants: "/Templates/Doccure/img/reviews/author-6.jpg" | "/Templates/Doccure/img/reviews/author-7.jpg" | "/Templates/Doccure/img/reviews/author-8.jpg" | "/Templates/Doccure/img/reviews/author-9.jpg" */
    src: string;
    /** Detected variants: "Carolyn Ross" | "Jamie Aurora" | "Evelyn Reed" | "James Porter" */
    h30Text: ReactNode;
    /** Detected variants: "Orlando, Florida" | "Lyon, France" | "Berlin, Germany" | "Seattle, Washington" */
    p0Text: ReactNode;
    /** Detected variants: "I saw rapid improvements in my skin after just a few sessions. The staff at Clear Skin Dermatology were very professional and helpful. I highly recommend!" | "The staff at Emerald Coast Dermatology are friendly and knowledgeable. They helped me create a skincare routine that has transformed my skin. I'm so grateful!" | "After struggling with acne for years, the team at Radiant Dermatology helped me find a solution that actually works. My skin is now clear and healthy. Thank you!" | "The clinic provided thorough consultation and effective treatments that noticeably enhanced my complexion. Friendly team and a welcoming atmosphere made." */
    p0P0Text: ReactNode;
    /** Detected variants: "testimonial-item-fourteen" */
    className?: string;
    /** Detected variants: "testimonial-user" */
    div0ClassName?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "author-info" */
    div2ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "mb-0" */
    p0ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName2?: string;
    ratingItems?: TestimonialsSectionFasFaStarFilledsItem[];
};

type TestimonialsSectionFasFaStarFilledsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fas fa-star filled" */
    className?: string;
};
export type HomeFourteenTestimonialsSectionGeneratedProps = {
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Words of" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Appreciation" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    /** Default: "from our Customers" */
    sectionDiv0Div0H20Span1SpanText?: ReactNode;
    sectionDiv0Div1Button0ButtonVisible?: boolean;
    sectionDiv0Div1Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Button0ButtonProps?: Partial<ComponentProps<"button">>;
    sectionDiv0Div1Button1ButtonVisible?: boolean;
    sectionDiv0Div1Button1ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Button1ButtonProps?: Partial<ComponentProps<"button">>;
    sectionDiv0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/testimonial-bg-06.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    swiperSlideSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: TestimonialsSectionSwipersItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    swiperSlideDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialsSectionSwipersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    swiperSlideDiv0Div2H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialsSectionSwipersItem) => Partial<ComponentProps<"h3">>);
    testimonialsSectionSwipers: TestimonialsSectionSwipersItem[];
    testimonialsSectionSwipersItemWrapper?: (item: TestimonialsSectionSwipersItem, content: ReactNode) => ReactNode;
    testimonialsSectionSwipersRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialsSectionSwipersImageVisible?: boolean;
    testimonialsSectionSwipersImageRenderer?: (item: TestimonialsSectionSwipersItem, defaultNode: ReactNode) => ReactNode;
    testimonialsSectionSwipersH3Visible?: boolean;
    testimonialsSectionSwipersH3Renderer?: (item: TestimonialsSectionSwipersItem, defaultNode: ReactNode) => ReactNode;
    testimonialsSectionSwipersImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialsSectionSwipersItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialsSectionSwipersH3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialsSectionSwipersItem) => Partial<ComponentProps<"h3">>);
    testimonialsSectionSwipersSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: TestimonialsSectionSwipersItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    testimonialsSectionFasFaStarFilledsItemWrapper?: (item: TestimonialsSectionFasFaStarFilledsItem, content: ReactNode) => ReactNode;
    testimonialsSectionFasFaStarFilledsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeFourteenTestimonialsSectionGenerated: FC<HomeFourteenTestimonialsSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Words of",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Appreciation",
    sectionDiv0Div0H20Span1SpanText = "from our Customers",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/testimonial-bg-06.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionDiv0Div1Button0ButtonVisible,
    sectionDiv0Div1Button0ButtonRenderer,
    sectionDiv0Div1Button0ButtonProps,
    sectionDiv0Div1Button1ButtonVisible,
    sectionDiv0Div1Button1ButtonRenderer,
    sectionDiv0Div1Button1ButtonProps,
    sectionDiv0Swiper0SwiperProps,
    swiperSlideDiv0Div0ImageWithBasePath0ImageProps,
    swiperSlideDiv0Div2H30H3Props,
    swiperSlideSwiperSlideProps,
    testimonialsSectionSwipers,
    testimonialsSectionSwipersItemWrapper,
    testimonialsSectionSwipersRenderer,
    testimonialsSectionSwipersImageVisible,
    testimonialsSectionSwipersImageRenderer,
    testimonialsSectionSwipersH3Visible,
    testimonialsSectionSwipersH3Renderer,
    testimonialsSectionSwipersImageProps,
    testimonialsSectionSwipersH3Props,
    testimonialsSectionSwipersSwiperSlideProps,
    testimonialsSectionFasFaStarFilledsItemWrapper,
    testimonialsSectionFasFaStarFilledsRenderer,
}) => {
    return (
        <section className="testimonial-section-fourteen section">
            <div className="container">
                <div className="section-header section-header-fourteen text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span className="section-line">{sectionDiv0Div0H20Span0SpanText}</span>
                            {" "}
                            <span className="subtitle">{sectionDiv0Div0H20Span1SpanText}</span>
                        </h2>
                    ))}
                </div>
                <Swiper modules={[Navigation]} loop={true} speed={2000} spaceBetween={24} slidesPerView={3} breakpoints={{
                    0: {
                        slidesPerView: 1
                    },
                    768: {
                        slidesPerView: 2
                    },
                    992: {
                        slidesPerView: 3
                    }
                }} className="testimonial-slider-fourteen" {...(sectionDiv0Swiper0SwiperProps ?? {})}>
                    {renderCollectionNode(
                        testimonialsSectionSwipers,
                        (item: TestimonialsSectionSwipersItem) => (
                            <SwiperSlide {...(typeof testimonialsSectionSwipersSwiperSlideProps === "function" ? testimonialsSectionSwipersSwiperSlideProps(item) : (testimonialsSectionSwipersSwiperSlideProps ?? {}))} {...(typeof swiperSlideSwiperSlideProps === "function" ? swiperSlideSwiperSlideProps(item) : (swiperSlideSwiperSlideProps ?? {}))} key={item.key}>
                                <div className={item.className ?? "testimonial-item-fourteen"}>
                                    <div className={item.div0ClassName ?? "testimonial-user"}>
                                        {renderItemNode(testimonialsSectionSwipersImageVisible, testimonialsSectionSwipersImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof testimonialsSectionSwipersImageProps === "function" ? testimonialsSectionSwipersImageProps(item) : (testimonialsSectionSwipersImageProps ?? {}))} {...(typeof swiperSlideDiv0Div0ImageWithBasePath0ImageProps === "function" ? swiperSlideDiv0Div0ImageWithBasePath0ImageProps(item) : (swiperSlideDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className="rating">
                                        {renderCollectionNode(
                                            item.ratingItems ?? [],
                                            (item: TestimonialsSectionFasFaStarFilledsItem) => (
                                                <i className={item.className ?? "fas fa-star filled"} key={item.key} />
                                            ),
                                            testimonialsSectionFasFaStarFilledsItemWrapper,
                                            testimonialsSectionFasFaStarFilledsRenderer
                                        )}
                                    </div>
                                    <p className={item.p0ClassName2 ?? "description"}>{item.p0P0Text}</p>
                                    <div className={item.div2ClassName ?? "author-info"}>
                                        {renderItemNode(testimonialsSectionSwipersH3Visible, testimonialsSectionSwipersH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof testimonialsSectionSwipersH3Props === "function" ? testimonialsSectionSwipersH3Props(item) : (testimonialsSectionSwipersH3Props ?? {}))} {...(typeof swiperSlideDiv0Div2H30H3Props === "function" ? swiperSlideDiv0Div2H30H3Props(item) : (swiperSlideDiv0Div2H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "mb-0"}>{item.p0Text}</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ),
                        testimonialsSectionSwipersItemWrapper,
                        testimonialsSectionSwipersRenderer
                    )}
                </Swiper>
                <div className="slide-nav view-all">
                    {renderNode(sectionDiv0Div1Button0ButtonVisible, sectionDiv0Div1Button0ButtonRenderer, (
                        <button type="button" className="slick-arrow testimonial-prev" {...(sectionDiv0Div1Button0ButtonProps ?? {})}>
                            <i className="isax isax-arrow-left" />
                        </button>
                    ))}
                    {renderNode(sectionDiv0Div1Button1ButtonVisible, sectionDiv0Div1Button1ButtonRenderer, (
                        <button type="button" className="slick-arrow testimonial-next" {...(sectionDiv0Div1Button1ButtonProps ?? {})}>
                            <i className="isax isax-arrow-right-1" />
                        </button>
                    ))}
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="testimonial-bg img-fluid" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFourteenTestimonialsSectionGenerated;
